import { initData } from '@telegram-apps/sdk-react';
import { localesMap } from '@helpers/localesMap.js';

export function checkIsPromoterRequest() {
  const startParam = initData.startParam();
  const defaultUser = {
    lang: null,
    contact_id: null,
    initiator_id: null,
  };

  if (!startParam) {
    return {
      isPromoterRequest: false,
      user: defaultUser,
      isEventAvailable: false,
    };
  }

  const promoterPattern = /^promoter_(rum|rus|ukr)_(\d+)_(\d+)_(\d+)$/;
  const match = startParam.match(promoterPattern);

  if (!match) {
    return {
      isPromoterRequest: false,
      user: defaultUser,
      isEventAvailable: false,
    };
  }

  const [, lang, initiator_id, contact_id, chat_id] = match;

  const promoterUser = {
    lang,
    formattedLang: localesMap[lang] ?? lang,
    initiator_id,
    contact_id,
    chat_id,
    isPromoter: true,
  };

  return {
    isPromoterRequest: true,
    user: promoterUser,
    isEventAvailable: true,
  };
}
